type CachedEnvelope<T> = {
  v: 1
  savedAt: number
  data: T
}

const PREFIX = 'ga_ehr_cache'

function buildKey(key: string): string {
  return `${PREFIX}:${key}`
}

export function readSessionCache<T>(key: string, maxAgeMs?: number): T | undefined {
  return readSessionCacheEnvelope<T>(key, maxAgeMs)?.data
}

export function readSessionCacheEnvelope<T>(
  key: string,
  maxAgeMs?: number
): { data: T; savedAt: number } | undefined {
  if (typeof window === 'undefined') return undefined

  const raw = window.sessionStorage.getItem(buildKey(key))
  if (!raw) return undefined

  try {
    const parsed = JSON.parse(raw) as CachedEnvelope<T>
    if (!parsed || parsed.v !== 1) return undefined
    if (typeof parsed.savedAt !== 'number') return undefined
    if (maxAgeMs && Date.now() - parsed.savedAt > maxAgeMs) return undefined
    return { data: parsed.data, savedAt: parsed.savedAt }
  } catch {
    return undefined
  }
}

export function writeSessionCache<T>(key: string, data: T): void {
  if (typeof window === 'undefined') return

  const envelope: CachedEnvelope<T> = {
    v: 1,
    savedAt: Date.now(),
    data,
  }
  try {
    window.sessionStorage.setItem(buildKey(key), JSON.stringify(envelope))
  } catch {
    // Storage full or blocked; fail closed to avoid breaking UI.
  }
}

export function removeSessionCache(key: string): void {
  if (typeof window === 'undefined') return
  window.sessionStorage.removeItem(buildKey(key))
}
